import * as React from 'react';
import { ExerciseType, DrillList } from '../../Drills/Drills';

interface LazyDrillLoaderProps {
  type: ExerciseType;
  number: number;
  drills: DrillList;
}

/**
 * 
 * @class LazyDrillLoader
 * @returns React.LazyExoticComponent<() => JSX.Element>
 */
class LazyDrillLoader extends React.PureComponent<LazyDrillLoaderProps, {}> {
  constructor(props: LazyDrillLoaderProps) {
    super(props);
  }

  render () {
    let LazyComponent = this.props.drills[this.props.type][this.props.number].component;

    return (<LazyComponent />);
  }
};

export default LazyDrillLoader;
